import {
    ADD_ALBUM_TYPE,
    REMOVE_ALBUM_TYPE,
    useAlbumContext
} from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useIsGroup from '@/utils/hooks/user/useIsGroup';

import { INSTAGRAM } from '@/lib/socialProfile';

import Icon from '@/components/base/Icon';
import RadioLabel from '@/components/composite/Radio/RadioLabel';

const InstagramMediaType = () => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();
    const { activeSocialProfile } = useActiveSocialProfile();
    const isGroup = useIsGroup();
    const network = activeSocialProfile?.social_network_type;
    const isStories = albumInfo?.criteria?.album_type === 'stories';

    if (albumInfo?.id || (!isGroup && network !== INSTAGRAM)) {
        return null;
    }

    return (
        <div className="pb-3 dark:border-icoDarkMode-beton sm:pb-4">
            <h3 className="mb-5 font-GSemiBold text-xl font-semibold leading-[25px] tracking-[-0.5px] text-icoBlack dark:text-white">
                {t('modal.label_instagram_type')}
            </h3>
            <div className="flex gap-3">
                <RadioLabel
                    variant="buttonSimple"
                    onChange={() => {
                        dispatch({
                            type: REMOVE_ALBUM_TYPE
                        });
                    }}
                    checked={!isStories}>
                    <span className="flex items-center">
                        <Icon icon="content" className="mr-3 text-base text-icoBlue" />
                        {t('modal.instagram_type_posts')}
                    </span>
                </RadioLabel>
                <RadioLabel
                    variant="buttonSimple"
                    onChange={() => {
                        dispatch({
                            type: ADD_ALBUM_TYPE,
                            payload: 'stories'
                        });
                    }}
                    checked={isStories}>
                    <span className="flex items-center">
                        <Icon icon="story" className="mr-3 text-base text-icoBlue" />
                        {t('modal.instagram_type_stories')}
                    </span>
                </RadioLabel>
            </div>
        </div>
    );
};

export default InstagramMediaType;
